// Datums en namen via Intl in de taal van het gezin (golf 3, talen). iOS 12.2 (de oude iPad) heeft
// Intl.DateTimeFormat met ICU-gegevens voor nl, en, tr, ar, de en fr, inclusief `timeZone: 'UTC'`
// en de -u-ca-/-u-nu-extensies; Intl.PluralRules (Safari 13) en Intl.RelativeTimeFormat (Safari 14)
// ontbreken daar, die gebruiken we dus nergens (zie plural.ts). Geen polyfill: als Intl een taal
// niet echt kent (resolvedOptions valt terug op een andere taal) blijven de Nederlandse namen staan.
import { localeInfo, intlTag } from './locales.js';
/** Sleutels die de catalogus uit Intl haalt als de vertaling ze (nog) niet heeft. */
export const INTL_DERIVED_KEYS = ['weekdays', 'weekdaysShort', 'months', 'monthsShort'];
const namesCache = {};
/** Maakt een formatter, of null als Intl de taal niet kent (of er niet is). */
export function safeFormatter(locale, options, digits = 'latn') {
    try {
        const f = new Intl.DateTimeFormat(intlTag(locale, digits), options);
        const resolved = f.resolvedOptions().locale.slice(0, 2).toLowerCase();
        return resolved === localeInfo(locale).lang ? f : null;
    }
    catch {
        return null;
    }
}
/**
 * Namen van weekdagen (maandag eerst, zoals de catalogus) en maanden, of null als Intl de taal
 * niet kent. Hoofdletters zoals Intl ze geeft (tr/de/fr/ar volgen hun eigen regels).
 */
export function intlCalendarNames(locale) {
    var _a;
    const key = localeInfo(locale).code;
    if (key in namesCache)
        return (_a = namesCache[key]) !== null && _a !== void 0 ? _a : null;
    const long = safeFormatter(locale, { weekday: 'long', timeZone: 'UTC' });
    const short = safeFormatter(locale, { weekday: 'short', timeZone: 'UTC' });
    const month = safeFormatter(locale, { month: 'long', timeZone: 'UTC' });
    const monthShort = safeFormatter(locale, { month: 'short', timeZone: 'UTC' });
    let names = null;
    if (long && short && month && monthShort) {
        const weekdays = [];
        const weekdaysShort = [];
        const months = [];
        const monthsShort = [];
        // 1 januari 2024 was een maandag.
        for (let i = 0; i < 7; i += 1) {
            const d = new Date(Date.UTC(2024, 0, 1 + i, 12));
            weekdays.push(long.format(d));
            weekdaysShort.push(short.format(d));
        }
        for (let i = 0; i < 12; i += 1) {
            const d = new Date(Date.UTC(2024, i, 15, 12));
            months.push(month.format(d));
            monthsShort.push(monthShort.format(d));
        }
        names = { weekdays, weekdaysShort, months, monthsShort };
    }
    namesCache[key] = names;
    return names;
}
/**
 * "woensdag 23 september" / "23 Eylül Çarşamba" / "الأربعاء، ٢٣ سبتمبر": de volgorde en de
 * leestekens van de taal zelf, via Intl. null als Intl de taal niet kent (de aanroeper valt terug).
 */
export function intlLongDate(locale, date, digits = 'latn') {
    const f = safeFormatter(locale, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }, digits);
    if (!f)
        return null;
    try {
        return f.format(new Date(Date.UTC(date.year, date.month - 1, date.day, 12)));
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=intl.js.map